// extracted by mini-css-extract-plugin
export var boxItems = "_87-1";
export var boxItemsLg = "_87-2";
export var button = "_87-7";
export var buttonHoverless = "_87-9";
export var buttonLg = "_87-8";
export var filterGroupBox = "_87-0";
export var icon = "_87-3";
export var iconSecondary = "_87-6";
export var iconWrapper = "_87-4";
export var iconWrapperLg = "_87-5";
export var truncatedLabel = "_87-a";